export default "__VITE_ASSET__DOxW2gGP__"